export const siteInfo = {
  name: '艳母的荒唐赌约',
  tagline: '一场荒唐的赌约，一段禁忌的纠缠，当欲望冲破理智的牢笼，谁才是最后的赢家？',
  description: '《艳母的荒唐赌约》是一部扣人心弦的都市情感小说，讲述了豪门深处一段荒诞不经却又引人深思的故事。小说以独特的视角展现了人性在欲望与道德之间的挣扎，情节跌宕起伏，人物刻画入微，深受广大读者喜爱。',
  keywords: '艳母的荒唐赌约,都市小说,情感文学,豪门故事,在线阅读',
  author: '匿名作者',
  year: 2024,
  totalChapters: 186,
  totalWords: '约 120 万字',
  status: '连载中',
  contactEmail: 'contact@example.com',
  socialLinks: {
    weibo: '#',
    wechat: '#',
    qq: '#',
  },
};